import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HealthInsurance } from '@shared/models';
import { BehaviorSubject, Observable, catchError, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface SearchHealthInsuranceResponse {
  message: string;
  data: HealthInsurance[];
}

@Injectable({
  providedIn: 'root',
})
export class HealthInsuranceService {
  private _http = inject(HttpClient);
  private _apiUrl = environment.apiUrl;
  private _authHeaders = new HttpHeaders({
    Authorization: '',
  });

  constructor() {
    this.searchHealthInsuranceList('');
    this.searchPrepaidList('');
  }

  #healthInsuranceList = new BehaviorSubject<HealthInsurance[]>([]);
  #prepaidList = new BehaviorSubject<HealthInsurance[]>([]);

  get healthInsuranceList(): Observable<HealthInsurance[]> {
    return this.#healthInsuranceList.asObservable();
  }

  get prepaidList(): Observable<HealthInsurance[]> {
    return this.#prepaidList.asObservable();
  }

  searchHealthInsuranceList(search: string): void {
    this._http
      .get(`${this._apiUrl}/api/healthinsurance/list`, {
        headers: this._authHeaders,
        params: {
          search,
        },
      })
      .pipe(
        tap((resp: any) => {
          this.#healthInsuranceList.next(resp.data);
        }),
        catchError((err) => {
          console.error('[Health Insurance Service Search]: ', err);
          return of([]);
        })
      )
      .subscribe();
  }

  searchPrepaidList(search: string): void {
    this._http
      .get(`${this._apiUrl}/api/prepaid/list`, {
        headers: this._authHeaders,
        params: {
          search,
        },
      })
      .pipe(
        tap((resp: any) => {
          this.#prepaidList.next(resp.data);
        }),
        catchError((err) => {
          console.error('[Prepaid Service Search]: ', err);
          return of([]);
        })
      )
      .subscribe();
  }

  setHealthInsuranceList(list: HealthInsurance[]): void {
    this.#healthInsuranceList.next(list);
  }

  setPrepaidList(list: HealthInsurance[]): void {
    this.#prepaidList.next(list);
  }
}
